module.exports = __webpack_public_path__ + "static/media/brainstorming.33d259a0.md";